import { Component, OnInit, ViewEncapsulation, Renderer2 } from '@angular/core';
import { Subscription, combineLatest } from 'rxjs';
import { Exam } from '../../models/exam';
import { ExamsService } from '../../services/exams.service';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { MenuUtils } from '../../../../../utils/menu-utils';
import { DateUtils } from '../../../../../utils/date-utils';
import { ComponentBase } from '../../../../../base-classes/componet-base';
import { ActivatedRoute } from '@angular/router';
import { RoutingService } from '../../../../../services/routing-service/routing.service';
import { PrifactRoute } from '../../../../../models/prifact-route';
import { PageHeadingService } from '../../../../../services/page-heading-service/page-heading.service';
import { pages } from '../../../../../utils/pages';

@Component({
  selector: 'app-exams',
  templateUrl: './exams.component.html',
  styleUrls: ['./exams.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ExamsComponent extends ComponentBase implements OnInit {

  constructor(
    private examsService: ExamsService
    , private pageHeadingService: PageHeadingService
    , private route: ActivatedRoute
    , private routingService: RoutingService
    , private renderer: Renderer2) {
    super();
  }

  subscription: Subscription;
  exams: Array<Exam>;
  upcoming: Array<Exam> = [];
  ongoing: Array<Exam> = [];
  past: Array<Exam> = [];
  selectedExam: Exam;
  loading: boolean = true;
  public config: PerfectScrollbarConfigInterface = {};

  ngOnInit() {
    this.pageHeadingService.menuOnChange(MenuUtils.getMenuItem("Exams"));
    this.subscription = combineLatest(this.examsService.getExams(), this.route.params)
      .subscribe(([res, params]) => {
        this.loading = false;

        this.upcoming = res.filter((obj) => {
          return obj.examination_status == 1;
        }).sort((a, b) => (a.exam_start_date > b.exam_start_date ? 1 : -1));

        this.ongoing = res.filter((obj) => {
          return obj.examination_status == 2;
        }).sort((a, b) => (a.exam_start_date > b.exam_start_date ? -1 : 1));

        this.past = res.filter((obj) => {
          return obj.examination_status == 3;
        }).sort((a, b) => (a.exam_start_date > b.exam_start_date ? -1 : 1));

        this.exams = res;
        let id = +params['id'];
        if (!id && this.exams.length) {
          let route = new PrifactRoute();
          route.replace_url = true;
          if (this.ongoing.length) {
            route.primary_command = ['pages', 'exams', this.ongoing[0].examination_id];
          }
          else if (this.upcoming.length) {
            route.primary_command = ['pages', 'exams', this.upcoming[0].examination_id];
          }
          else if (this.past.length) {
            route.primary_command = ['pages', 'exams', this.past[0].examination_id];
          }
          this.routingService.navigate(route);
        }
        else if (id) {
          this.selectedExam = this.exams.find(o => o.examination_id == id);
        }
      })
    this.addSubscription(this.subscription);
  }

  examClicked(exam: Exam) {
    let route = new PrifactRoute();
    route.replace_url = true;
    route.append_current_url_to_history = true;
    route.primary_command = ['pages', 'exams', exam.examination_id]
    route.page_name = pages.examDetails;
    this.routingService.navigate(route);
    this.renderer.addClass(document.body, 'second-page');
  }

  isResultPublished(exam: Exam) {
    let published = exam.tests.find(o => o.subject_mark != null || o.subject_grade != 0);
    if (published) {
      return true;
    }
  }

  findProgressInPercentage(exam: Exam) {
    let oneDay = 24 * 60 * 60 * 1000;
    let firstDate = DateUtils.parseDateAndTime(exam.exam_start_date.split('T')[0]);
    let secondDate = DateUtils.parseDateAndTime(exam.exam_end_date.split('T')[0]);
    let today = DateUtils.parseDateAndTime(new Date().toISOString().split('T')[0]);
    let startEndDiff = Math.round(Math.abs((firstDate.getTime() - secondDate.getTime()) / (oneDay)));
    let startTodayDiff = Math.round(Math.abs((firstDate.getTime() - today.getTime()) / (oneDay)));
    return (startTodayDiff / startEndDiff) * 100;
  }

}
